import React, { useContext } from 'react'
import { trackingTypes, trackingNullValue } from '../../constants'
import { PromotionPositionContext, FeatureFlagsContext } from '../../context'

const Trackable: React.FC<TrackableProps> = ({
  children,
  trackingAction,
  type,
  correlationId,
  displayId,
  title,
  position,
  creative,
  promotion,
}) => {
  const enableMeasurement = useContext(FeatureFlagsContext)
    .FEAT_FLAG_MEASUREMENT
  return (
    <PromotionPositionContext.Consumer>
      {promotionPosition =>
        enableMeasurement ? (
          <div
            {...type === trackingTypes.promotion && {
              'data-promotion': true,
            }}
            data-trackable-action={trackingAction}
            data-trackable-correlation-id={
              correlationId || displayId || trackingNullValue
            }
            data-promotion-id={correlationId || displayId || trackingNullValue}
            data-promotion-name={title || position || trackingNullValue}
            data-promotion-creative={
              creative || (promotion && promotion.creative) || trackingNullValue
            }
            data-promotion-slot={
              promotionPosition || position || trackingNullValue
            }
          >
            {children}
          </div>
        ) : (
          <div>{children}</div>
        )
      }
    </PromotionPositionContext.Consumer>
  )
}

export interface TrackableProps {
  trackingAction: string
  type: string
  correlationId?: string
  displayId?: string
  title?: string
  position?: string
  creative?: string
  promotion?: PromotionProps
}

interface PromotionProps {
  creative?: string
}

export default Trackable
